import { render, staticRenderFns } from "./BrigadeMapBrigadeInformation.vue?vue&type=template&id=e1ee09e4&"
import script from "./BrigadeMapBrigadeInformation.vue?vue&type=script&lang=js&"
export * from "./BrigadeMapBrigadeInformation.vue?vue&type=script&lang=js&"
import style0 from "./BrigadeMapBrigadeInformation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QItem,QInput,QIcon,QCheckbox,QSelect,QBanner} from 'quasar'
component.options.components = Object.assign({QCard,QItem,QInput,QIcon,QCheckbox,QSelect,QBanner}, component.options.components || {})
